import { render, staticRenderFns } from "./productBasicInfo.vue?vue&type=template&id=3d7cac40&scoped=true"
import script from "./productBasicInfo.vue?vue&type=script&lang=js"
export * from "./productBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./productBasicInfo.vue?vue&type=style&index=0&id=3d7cac40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7cac40",
  null
  
)

export default component.exports